var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tetris"},[_c('player',{ref:"player",attrs:{"stage":_vm.stage,"keys":{ straight: 90, left: 37, rotate: 32, right: 39, down: 40 }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }